var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"greeter"},[_c('h1',{staticClass:"greeter__heading"},[_vm._v(_vm._s(_vm.greeting)+_vm._s(_vm.user ? ` ${_vm.user.fullname}` : ''))])])
}
var staticRenderFns = []

export { render, staticRenderFns }